import {createContext, useContext, useState} from "react";
const AuthContext = createContext(null);
export const AuthProvider = ({children}) => {
 const [authModalOpen,setOpen]=useState(false);
 return <AuthContext.Provider value={{user:false,authModalOpen,openAuthModal:()=>setOpen(true),closeAuthModal:()=>setOpen(false),setUser:()=>{},signOut:async()=>{}}}>{children}</AuthContext.Provider>;
};
export const useAuth = () => useContext(AuthContext);
